<template>
  <v-dialog v-model="dialogVisible" 
    persistent
    max-width="360px" 
  >
    <template #activator="{ on }">
      <v-btn fab x-small rounded dark class="ml-2" color="primary" v-on="on">
        <v-icon dark>mdi-plus</v-icon>
      </v-btn>
    </template>

    <v-form v-show="page1" lazy-validation ref="page1" @submit.prevent="nextClick" autocomplete="off">
      <v-card>
        <v-card-title style="background-color: #004056" class="white--text py-2">
          Create a Pro
        </v-card-title>

        <v-divider />

        <v-card-text class="d-flex flex-column" style="row-gap: 12px;">
          <v-text-field
            outlined dense hide-details="auto"
            autocomplete="business_name"
            v-model="business_name"
            label="Business Name"
            :rules="[required]"
            validate-on-blur
          />
          <v-text-field
            outlined dense hide-details="auto"
            v-model="contact_name"
            label="Contact Name"
            :rules="[required]"
            validate-on-blur
            autocomplete="contact_name"
          />
          <v-text-field
            ref="phoneField"
            outlined dense hide-details="auto"
            v-mask="'(###) ###-####'"
            v-model="phone"
            label="Business Cell"
            :rules="[required]"
            autocomplete="phone_number"
            validate-on-blur
          />
          <SimpleGoogleAutocomplete
            outlined dense persistent-placeholder clearable hide-details="auto"
            autocomplete="address_fields"
            placeholder="Business Address, use yours if unknown"
            country="us"
            :rules="[required, full_address]"
            @placechanged="updateAddressData"
            v-model="address_string"
          />

        </v-card-text>

        <v-divider />

        <v-card-actions class="justify-center py-3">
          <v-btn @click="close">Cancel</v-btn>
          <v-btn type="submit" color="primary">Next</v-btn>
        </v-card-actions>

      </v-card>
    </v-form>

    <v-form v-show="!page1" ref="page2" @submit.prevent="submitClick">
      <v-card class="d-flex flex-column">
        <v-card-title style="background-color: #004056" class="white--text py-2">
          Create a Pro
        </v-card-title>

        <v-divider />

        <v-card-text class="flex-grow-1" style="row-gap: 12px;">
          <TradesInput v-model="trade_ids" />
        </v-card-text>

        <v-divider />

        <v-card-actions class="justify-center py-3">
          <v-btn @click="backClick">Back</v-btn>
          <v-btn type="submit" color="primary" :disabled="trade_ids.length < 1">Create</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>

    <ErrorOverlay
      title="Error Creating Pro" v-model="error_dialog"
      :loading="loading"
    >
      {{ error_message }}
    </ErrorOverlay>
  </v-dialog>
</template>

<script>
import { ErrorOverlay } from '@/components/pages'
import { SimpleGoogleAutocomplete, TradesInput } from '@/components/inputs'

import { mapActions } from 'vuex'
import { required, valid_us_phone } from '@/lib/validations'

export default {
  components: { ErrorOverlay, SimpleGoogleAutocomplete, TradesInput },
  
  data() {
    return {
      dialogVisible: false,
      
      page1: true,

      address_string: '',
      business_name: '',
      contact_name: '',
      phone: '',
      
      address: {
        place_id: '',
        coords: '',
        street: '',
        city: '',
        state: '',
        zipcode: '',
      },

      trade_ids: [],

      // for error messages
      loading: false,
      error_dialog: false,
      error_message: '',

      // validation rules
      required, valid_us_phone,
    }
  },

  computed: {
    // validation rules
    full_address() { 
      if (this.address.place_id != '' && this.address.street != ''&& this.address.coords != '') return true
      return  'Please choose a full street address'
    },
  },

  methods: {
    ...mapActions('pros', ['createPro']),

    updateAddressData(addressData) {
      this.address.place_id = addressData.place_id
      this.address.coords = `POINT(${addressData.longitude} ${addressData.latitude})`
      this.address.street = addressData.name
      this.address.city = addressData.locality
      this.address.state = addressData.administrative_area_level_1
      this.address.zipcode = addressData.postal_code
    },

    close() {
      this.dialogVisible = false
      this.page1 = true
    },

    backClick() {
      this.page1 = true
      console.log('back click', this.page1)
    },

    nextClick() {
      if(!this.$refs.page1.validate()) {
        return false
      }

      this.page1 = false
    },

    async submitClick() {
      this.loading = true

      let payload = { 
        business_name: this.business_name,
        contact_name: this.contact_name,
        phone: this.phone,

        address: this.address,
        trade_ids: this.trade_ids,
      }

      const result = await this.createPro(payload)
      this.loading = false
      
      if(result.ok) {
        this.$router.push( { name: 'pros/show', params: { pro_id: result.created.pro_id } } )
      } else {
        this.error_dialog = true
        this.error_message = result.error
      }
    },
  },
}

</script>